// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export default () => document.documentElement.dir === 'rtl';
